var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"cw-alert",attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-alert',_vm._b({staticClass:"mb-0"},'v-alert',_vm.$attrs,false),[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }